<template>
  <div>
    <v-card>
      <v-system-bar dark color="grey darken-1" height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        {{ ParcoursEffectif.nom_groupe }} -  {{ ParcoursEffectif.ll_parcours }}  -
        {{ ParcoursEffectif.ll_parcours_effectif }} -
        {{ $moment(ParcoursEffectif.ll_mois).format("MMMM YYYY") }}
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>

      <v-card-text>
      
        <etapesEffectives
          :parcoursEffectif="ParcoursEffectif"
          v-if="ParcoursEffectif"
          :id="$route.params.id"
          :key="key"
          @resetKey="resetKey()"
        />
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      key: this.$uuid.v4(),
    };
  },
  created() {
    this.GetParcoursEffectifById(this.$route.params.id);
  },

  components: {
    etapesEffectives: require("@/components/groupes/etapesEffectives.vue")
      .default,
  },
  methods: {
    ...mapActions({
      GetParcoursEffectifById: "ParcoursEffectif/GetParcoursEffectifById",
    }),
    resetKey() {
      this.key = this.$uuid.v4();
      this.GetParcoursEffectifById(this.$route.params.id);
    },
  },
  computed: {
    ...mapState({
      ParcoursEffectif: (state) => state.ParcoursEffectif.ParcoursEffectifById,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
